import React from 'react';
import { get } from 'lodash';
import { isVM, getBrandId } from '../../utils/BrandUtils';

const viewBox = {
  'alerts-media-image': '0 0 221 160',
};

const iconSource = {
  VM: {
    'icon-flip-chart-outline': {
      path: '../images/vm/icon-flip-chart-outline.svg',
      iconHeight: '32px',
      iconWidth: '32px',
    },
  },
  CB: {
    'icon-flip-chart-outline': 'icon-graph',
  },
};

const SvgIcon = ({
  id,
  svgType,
  width = '32px',
  height = '32px',
  className,
}) => {
  const iconInfo = get(iconSource, [getBrandId(), id]);
  if (isVM() && iconInfo) {
    const { path, iconWidth, iconHeight } = iconInfo;
    return (
      <img
        aria-hidden="true"
        src={path}
        width={iconWidth}
        height={iconHeight}
        style={{ height: iconHeight, width: iconWidth }}
        className={className}
        alt={id}
      />
    );
  }
  return (
    <svg
      role="img"
      aria-hidden="true"
      className={className}
      viewBox={viewBox[svgType] || '0 0 32 32'}
      width={width}
      height={height}
    >
      <use xlinkHref={`../images/bow/bow-sprite.svg#${iconInfo || id}`} />
    </svg>
  );
};

export default SvgIcon;
